import React from 'react';
import { Link } from 'react-router-dom';
import LandingContainer from './LandingContainer';
import { APP_URL } from './urls';
import { useT, useLang, downloadPathFor } from './i18n';

const LandingFooter = () => {
  const t = useT();
  const downloadPath = downloadPathFor(useLang());
  return (
  <footer className="landing-footer">
    <LandingContainer className="landing-footer__inner">
      <div>
        <span className="landing-footer__brand">Effzone</span>
        <span> · </span>
        <span>© {new Date().getFullYear()}</span>
      </div>
      <div className="landing-footer__links">
        <Link to={downloadPath}>{t('footer.downloadApp')}</Link>
        <Link to="/privacy-policy">{t('footer.privacy')}</Link>
        <Link to="/obchodne-podmienky">{t('footer.terms')}</Link>
        <Link to="/subdodavatelia">{t('footer.subprocessors')}</Link>
        <a href={APP_URL}>{t('footer.admin')}</a>
      </div>
    </LandingContainer>
  </footer>
  );
};

export default LandingFooter;
